<ng-container  *transloco="let t;">
  <psc-dialog
    [maxWidthPercentage]="50"
    *ngIf="showWarningDialog"
    [title]="t('warning_text_title')"
    (closeClicked)="showWarningDialog = false">
    <div class="flex flex-col gap-5 items-center">
      <div class="whitespace-pre-wrap text-magenta">{{warningText}}</div>
      <psc-button
        (buttonClicked)="showWarningDialog = false"
        type="secondary-yellow"
        [label]="t('common.close')"></psc-button>
    </div>
  </psc-dialog>

</ng-container>
